import React, { useState, useEffect } from 'react';

import dynamic from 'next/dynamic';

import JSONViewer from '../JSONViewer/JSONViewer';

const ExcalidrawViewer = dynamic(
  () => import('@/components/Excalidraw/ExcalidrawViewer'),
  { ssr: false }
);

const IPFSTextFileViewer = ({ url }: { url: string }) => {
  const [file, setFile] = useState<any>({});
  useEffect(() => {
    (async () => {
      const fileData = await (await fetch(url)).text();
      setFile(JSON.parse(fileData));
    })();
  }, []);
  if (file && file.source && file.source === 'fileverse-excalidraw')
    return <ExcalidrawViewer file={file.file} />;
  return (
    <div>
      <JSONViewer file={file} />
    </div>
  );
};

export default IPFSTextFileViewer;
